// extracted by mini-css-extract-plugin
export default {"pawWrapper":"styles_pawWrapper__L5wUR","paw":"styles_paw__+wFAp"};